import { ButtonBase as MuiButtonBase, ButtonBaseProps as MuiButtonBaseProps } from '@material-ui/core';
import { forwardRef } from 'react';

interface ButtonProps extends Omit<MuiButtonBaseProps, 'children'> {
  children?: React.ReactNode;
  component?: React.ElementType;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ children, component = 'button', ...rest }, ref) => (
  <MuiButtonBase ref={ref} component={component} {...rest}>
    {children}
  </MuiButtonBase>
));

Button.displayName = 'Button';
